import { Box, Typography, alpha } from "@mui/material";
import {
  Info as InfoIcon,
  CalendarMonth as CalendarIcon,
  AttachMoney as MoneyIcon,
  Groups as GroupsIcon,
  EventAvailable as EventIcon,
} from "@mui/icons-material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { ModernCard } from "./shared/ModernCard";

export const CardDadosComplementarModern = () => {
  const { valueContractInternal } = useContextContrato();

  if (!valueContractInternal) return null;

  const { mensalidade_value, vidas, vigencia_data, emissao_data } =
    valueContractInternal;

  const infoCards = [
    {
      icon: <CalendarIcon />,
      label: "Data de Emissão",
      value: FormatDateBR(emissao_data),
      color: "#3b82f6",
    },
    {
      icon: <EventIcon />,
      label: "Data de Vigência",
      value: FormatDateBR(vigencia_data),
      color: "#10b981",
    },
    {
      icon: <MoneyIcon />,
      label: "Mensalidade",
      value: `R$ ${FormatMoney(mensalidade_value)}`,
      color: "#f59e0b",
    },
    {
      icon: <GroupsIcon />,
      label: "Vidas",
      value: vidas?.toString() || "0",
      color: "#8b5cf6",
    },
  ];

  return (
    <ModernCard title="Dados Complementares" icon={<InfoIcon />}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        {infoCards.map((item) => (
          <Box
            key={item.label}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              p: { xs: 2, sm: 2.5 },
              borderRadius: "14px",
              bgcolor: alpha(item.color, 0.08),
              border: "1px solid",
              borderColor: alpha(item.color, 0.15),
              transition: "all 0.2s ease",
              "&:hover": {
                bgcolor: alpha(item.color, 0.12),
                transform: "translateY(-2px)",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 44,
                height: 44,
                borderRadius: "12px",
                bgcolor: alpha(item.color, 0.15),
                color: item.color,
                mb: 1.5,
                "& svg": { fontSize: 24 },
              }}
            >
              {item.icon}
            </Box>
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                fontSize: { xs: "10px", sm: "11px" },
                fontWeight: 500,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                textAlign: "center",
                mb: 0.5,
              }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "text.primary",
                fontWeight: 700,
                fontSize: { xs: "14px", sm: "16px" },
                textAlign: "center",
              }}
            >
              {item.value || "-"}
            </Typography>
          </Box>
        ))}
      </Box>
    </ModernCard>
  );
};
